/* eslint-disable max-len */
import React from 'react';

const MoreDetailed: React.FC<object> = () => {

    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6575_138712)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6 0C4.40869 8.83976e-07 2.883 0.632595 1.75781 1.75781C0.63257 2.88303 7.57665e-07 4.4087 0 6C0 7.59131 0.632565 9.117 1.75781 10.2422C2.883 11.3674 4.40869 12 6 12C7.5913 12 9.11697 11.3674 10.2422 10.2422C11.3674 9.117 12 7.59131 12 6C12 4.4087 11.3674 2.88303 10.2422 1.75781C9.11697 0.632594 7.5913 0 6 0ZM4.46875 2.96973C4.76155 2.67697 5.2364 2.67716 5.5293 2.96973L8.02539 5.46387C8.02693 5.46538 8.02874 5.46721 8.03027 5.46875C8.03331 5.47178 8.03611 5.47543 8.03906 5.47852L8.08301 5.52832C8.08873 5.53535 8.09323 5.54358 8.09863 5.55078C8.11454 5.57197 8.12921 5.59383 8.14258 5.61621C8.1535 5.63441 8.16361 5.65301 8.17285 5.67188C8.1822 5.69109 8.19064 5.71068 8.19824 5.73047C8.20807 5.75585 8.21667 5.7815 8.22363 5.80762C8.22807 5.82444 8.2321 5.84136 8.23535 5.8584C8.2406 5.88559 8.24387 5.91291 8.24609 5.94043C8.24737 5.9567 8.24685 5.97295 8.24707 5.98926C8.24754 6.01966 8.24735 6.04981 8.24414 6.08008C8.2428 6.09248 8.24121 6.10485 8.23926 6.11719C8.23392 6.15123 8.22585 6.18459 8.21582 6.21777C8.21313 6.2266 8.21005 6.23539 8.20703 6.24414C8.19544 6.27785 8.18157 6.31066 8.16504 6.34277C8.16066 6.35125 8.15609 6.35982 8.15137 6.36816C8.13246 6.4016 8.11136 6.43403 8.08691 6.46484C8.08496 6.46733 8.08306 6.4702 8.08105 6.47266L8.06641 6.48926C8.05462 6.50291 8.0442 6.51829 8.03125 6.53125C8.0266 6.53582 8.02032 6.53949 8.01562 6.54395L5.5293 9.03027C5.23641 9.32283 4.76155 9.32298 4.46875 9.03027C4.17616 8.73747 4.17623 8.26258 4.46875 7.96973L6.43848 5.99902L4.46875 4.03027C4.17643 3.73757 4.17666 3.26255 4.46875 2.96973Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_6575_138712">
                    <rect
                        width="12"
                        height="12"
                        fill="white"
                        transform="matrix(-1 0 0 1 12 0)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default MoreDetailed;